export default "__VITE_ASSET__m5Ymify2__"